import { Pipe, PipeTransform } from '@angular/core';
import { DatesUtil } from '@liberty-financial/ng-core';

@Pipe({
  name: 'diaryNoteDisplayCreatedDate'
})
export class DiaryNoteDisplayCreatedDatePipe implements PipeTransform {
  transform(isNewDiaryNote: boolean, date: string | null): boolean {
    return (
      !isNewDiaryNote && !!DatesUtil.convertToDate((date ?? '').split('T')[0])
    );
  }
}
